export enum AdminSearchType {
    Driver = 'DRIVER',
    Vehicle = 'VEHICLE',
    Device = 'DEVICE',
    Terminal = 'TERMINAL',
    Client = 'CLIENT',
}

export interface AdminSearchOption {
    value: AdminSearchType;
    label: string;
}

// Item shape depends on searchBy:
// DRIVER -> firstName, lastName, cardNumber; VEHICLE -> registrationNumber, identificationNumber;
// DEVICE -> imei; TERMINAL -> name, mac, registrationNumber; CLIENT -> name.
export interface AdminSearchItem {
    id: number;
    firstName?: string;
    lastName?: string;
    cardNumber?: string;
    registrationNumber?: string;
    identificationNumber?: string;
    imei?: string;
    name?: string;
    mac?: string;
    [key: string]: unknown;
}

export interface AdminSearchNode {
    clientId: number;
    clientName: string;
    children: AdminSearchNode[];
    level: number;
    items: AdminSearchItem[];
}

export interface SearchResponse {
    Message: string;
    Data: AdminSearchNode[];
    Result: string;
}

// Flattened row: one item together with the company it belongs to and its hierarchy path.
export interface AdminSearchResult {
    itemLabel: string;
    itemDetails: string;
    itemId: number;
    companyId: number;
    companyName: string;
    companyPath: string;
    filterValue: string;
}
